import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const tourAreaApi = createApi({
  reducerPath: 'tourAreaApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers) => {
      const user = localStorage.getItem('hthUser');
      const token = user ? JSON.parse(user).token : null;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['TourArea', 'Country', 'Sightseen'],
  endpoints: (builder) => ({
    getTourAreas: builder.query({
      query: () => '/api/admin/getAllTourArea',
      providesTags: ['TourArea'],
    }),

    getTourAreaById: builder.query({
      query: (id) => `/api/admin/getTourAreaById/${id}`,
      providesTags: ['TourArea'],
    }),

    addEditTourArea: builder.mutation({
      query: (formData) => ({
        url: '/api/admin/addEditTourArea',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['TourArea'],
    }),

    deleteTourArea: builder.mutation({
      query: (id) => ({
        url: `/api/admin/deleteTourArea/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TourArea'],
    }),

    // Country related endpoints
    getCountries: builder.query({
      query: () => '/api/admin/getCountry',
      providesTags: ['Country'],
    }),

    addCountry: builder.mutation({
      query: (data) => ({
        url: '/api/admin/addCountry',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Country'],
    }),

    // Sightseen related endpoints
    addSightSeen: builder.mutation({
      query: (formData) => ({
        url: '/api/admin/addSightScene',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Sightseen', 'TourArea'],
    }),

    getSightseens: builder.query({
      query: (tourAreaId) => `/api/admin/getSightScene/${tourAreaId}`,
      providesTags: ['Sightseen'],
    }),
  }),
});

export const {
  useGetTourAreasQuery,
  useGetTourAreaByIdQuery,
  useAddEditTourAreaMutation,
  useDeleteTourAreaMutation,
  useGetCountriesQuery,
  useAddCountryMutation,
  useAddSightSeenMutation,
  useGetSightseensQuery,
} = tourAreaApi;
